import { Button, Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import React, { useEffect, useState } from 'react';
import './login.css';
import { useForm } from 'react-hook-form';
import { json, useNavigate, useSearchParams } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import TextFieldComponent from '../../components/TextField/TextField';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function ForgotPassword() {
	let navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [waitCssImg, setWaitCssImg] = useState(true);
	const [department, setDepartment] = useState('');
	const [email, setEmail] = useState('');
	const [otp, setOtp] = useState('');

	const { register, formState: { errors }, handleSubmit, setError, setValue } = useForm({
		defaultValues: {
			department: localStorage.getItem('department'),
		}
	});

	const onSubmit = () => {
		setLoading(true);
		const body = {
			"email": email,
			"otp": otp
		}
		const url = `https://${department}.${process.env.REACT_APP_FIREHOUSE_API_URL}/forgetPasswordCheckOTP`
		axios.post(url, body)
			.then(response => {
				toast.success(response?.data?.message)
				navigate(`/new-password?token=${response?.data?.token}`);
			})
			.catch((response) => {
				setLoading(false)
				toast.error(response?.response?.data)
			});
	};

	useEffect(() => {
		const storedEmail = localStorage.getItem('email');
		if (storedEmail) {
			setEmail(storedEmail);
		}
		const storedDepartment = localStorage.getItem('department');
		if (storedDepartment) {
			setDepartment(storedDepartment);
		}
	}, []);

	return (
		<>
			<img src='/images/main-login-img-new.png' className='d-none' onLoad={() => setWaitCssImg(false)} />
			<div className='main-login' style={{ visibility: waitCssImg ? 'hidden' : 'visible' }}>
				<div className='login-content-box'>
					<div className='login-content'>

						<form onSubmit={handleSubmit(onSubmit)} className='login-width flex-grow-1 '>
							<div className='login-box'>
								<Grid container rowSpacing={2} columnSpacing={{ xs: 12, sm: 2, md: 3 }}>

									<Grid xs={12}>
										<Box sx={{ my: 2 }} >
											<img className='w-100 mb-3' src='/images/logo.svg' />
										</Box>
									</Grid>

									<Grid xs={12}>
										{/* <TextFieldComponent
											register={register('otp', { 
												required: "Please enter OTP",
												pattern: {
													value: /^[0-9]+$/,
													message: "Only numbers are allowed"
												}
											})}
											type="text"
											inputMode="numeric"
											pattern="[0-9]*"
											autoFocus
											placeholder="Enter your OTP"
											label="Enter OTP"
											onChange={(e) => setOtp(e.target.value)}
											endAdornment={
												<InputAdornment position="end">
													<img src="/images/otp.png" alt="icon" style={{width: '24px'}} />
												</InputAdornment>
											}
										/> */}
										
										<TextFieldComponent
											register={register('otp', {
												required: "Please enter OTP",
												pattern: {
													value: /^[0-9]+$/,
													message: "Only numbers are allowed"
												}
											})}
											type="text"
											inputMode="numeric"
											pattern="[0-9]*"
											autoFocus
											placeholder="Enter your OTP"
											label="Enter OTP"
											onChange={(e) => {
												const value = e.target.value;
												if (/^\d*$/.test(value)) {
													setOtp(value);
												}
											}}
											onKeyDown={(e) => {
												if (
													['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key)
												) {
													return;
												}
												if (!/^[0-9]$/.test(e.key)) {
													e.preventDefault();
												}
											}}
											onPaste={(e) => {
												const paste = e.clipboardData.getData('text');
												if (!/^\d+$/.test(paste)) {
													e.preventDefault();
												}
											}}
											endAdornment={
												<InputAdornment position="end">
													<img src="/images/otp.png" alt="icon" style={{ width: '24px' }} />
												</InputAdornment>
											}
										/>

										{errors.otp && <p style={{ color: 'red' }}>{errors.otp?.message}</p>}
									</Grid>

									<Grid xs={12}>
										<Box sx={{ my: 2 }}>
											<Button className='rounded-5 text-capitalize login-button' type='submit' fullWidth={true} variant="contained" color='error' disabled={loading}>
												{loading ? 'Loading' : 'Submit'}
											</Button>
										</Box>
									</Grid>
								</Grid>
							</div>
						</form>

						<Grid className='flex-grow-1 text-white d-flex align-items-end'>
							<p>
								Copyright <a className='textfeild_white' target='_blank' href='https://247software.cloud'>247software.cloud</a> 2023
							</p>
						</Grid>
					</div>
				</div>
			</div>
		</>
	);
}